import { render, staticRenderFns } from "./ActivityHistory.vue?vue&type=template&id=5e906214&scoped=true&"
import script from "./ActivityHistory.vue?vue&type=script&lang=js&"
export * from "./ActivityHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e906214",
  null
  
)

export default component.exports